import { useState } from "react";
import { useToggleSkipConstructionSite } from "../../../api/mutations/constructionSite.mutations";

export const useSkipDialog = (entityId: string, onSuccess?: () => void) => {
	const [skipReason, setSkipReason] = useState<string>("");
	const [isSkipDialogOpen, setIsSkipDialogOpen] = useState(false);
	const [isUnskipDialogOpen, setIsUnskipDialogOpen] = useState(false);

	const toggleSkipMutation = useToggleSkipConstructionSite();

	const handleSkipConstruction = () => {
		toggleSkipMutation.mutate(
			{
				id: entityId,
				skipReason,
			},
			{
				onSuccess: () => {
					onSuccess?.();
				},
			},
		);
		setIsSkipDialogOpen(false);
		setSkipReason("");
	};

	const handleUnskipConstruction = () => {
		toggleSkipMutation.mutate(
			{
				id: entityId,
			},
			{
				onSuccess: () => {
					onSuccess?.();
				},
			},
		);
		setIsUnskipDialogOpen(false);
	};

	const handleSkipDialogClose = () => {
		setIsSkipDialogOpen(false);
		setSkipReason("");
	};

	const handleUnskipDialogClose = () => {
		setIsUnskipDialogOpen(false);
	};

	return {
		skipReason,
		setSkipReason,
		isSkipDialogOpen,
		setIsSkipDialogOpen,
		isUnskipDialogOpen,
		setIsUnskipDialogOpen,
		handleSkipConstruction,
		handleUnskipConstruction,
		handleSkipDialogClose,
		handleUnskipDialogClose,
		isPending: toggleSkipMutation.isPending,
	};
};

export const getSkipReasonLabel = (reason: string) => {
	switch (reason) {
		case "placed_elsewhere":
			return "J'ai placé l'affaire ailleurs";
		case "not_realized":
			return "Je n'ai pas réalisé l'affaire";
		default:
			return reason;
	}
};
